var indexOf = [].indexOf;

import qs from 'qs';

import plural from 'helpers/plural';

import featureNames from 'constants/feature_names';

angular.module('gym.bulkUpdates').directive('bulkUpdateConfirmChanges', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/bulk_updates/show/bulk_update_confirm_changes.html.slim'),
    scope: {
      bulkUpdate: '=',
      visible: '=',
      membershipPlanCategories: '=',
      goToFilters: '&',
      confirmChanges: '&',
      meta: '='
    },
    controller: ["$scope", "$rootScope", "$http", "$filter", "$modal", "loadingAnimation", "flash", "TableService", "ActionCable", "MessageService", function($scope, $rootScope, $http, $filter, $modal, loadingAnimation, flash, TableService, ActionCable, MessageService) {
      var bulkUpdateUrl, currency, gym, unsubscribe, updateErrorsCount;
      $scope.gym = gym = $rootScope.gym;
      $scope.currency = currency = gym.currency_symbol;
      $scope.featureNames = featureNames;
      unsubscribe = ActionCable.create({
        channel: 'BulkRecordUpdatesChannel',
        uuid: $scope.bulkUpdate.uuid
      }, function(message) {
        if (message.message === 'validation_status_updated') {
          return $scope.reloadDebounced();
        }
      });
      $scope.$on('$destroy', function() {
        return unsubscribe();
      });
      $rootScope.$on('bulkImport:confirmChanges:setFilter', function(event, value) {
        return $scope.filters.type = value;
      });
      $scope.isColumnAvailable = function(column) {
        return indexOf.call($scope.meta.updateable_columns[$scope.bulkUpdate.update_type], column) >= 0;
      };
      bulkUpdateUrl = `/gyms/${gym.id}/bulk_update/bulk_updates/${$scope.bulkUpdate.id}/rows`;
      $scope.$watch('visible', function(visible, previousVisible) {
        if (visible && !previousVisible && $scope.rowsTable) {
          return $scope.reload();
        }
      });
      $scope.$watch('bulkUpdate.status', function(status, previousStatus) {
        if ($scope.visible && status !== previousStatus && previousStatus) {
          return $scope.reload();
        }
      });
      $scope.isLocked = function() {
        var ref;
        return (ref = $scope.bulkUpdate.status) === 'queued_for_update' || ref === 'updating' || ref === 'update_complete' || ref === 'update_failed';
      };
      $scope.isDataProcessingInProgress = function() {
        return $scope.bulkUpdate.status === 'generating_rows';
      };
      $scope.isDataProcessingFailed = function() {
        return $scope.bulkUpdate.status === 'row_generation_failed';
      };
      $scope.pageRange = function() {
        var fromCount, prevPagesCount;
        prevPagesCount = ($scope.rows.page - 1) * $scope.rows.count;
        fromCount = $scope.rows.collection.length ? prevPagesCount + 1 : 0;
        return `${fromCount} - ${prevPagesCount + $scope.rows.collection.length}`;
      };
      $scope.parseAmount = function(amount) {
        var value;
        value = parseFloat(amount);
        if (value > 0) {
          return value;
        }
      };
      $scope.formatAmount = function(amount) {
        var value;
        value = $scope.parseAmount(amount);
        if (value) {
          return $filter('currency')(value, currency);
        } else {
          return 'N/A';
        }
      };
      $scope.getPhoneNumber = function(recipient) {
        return recipient.recipient_phone_number || recipient.non_internationalized_recipient_phone_number;
      };
      $scope.getCategoryLabel = function(id) {
        var category;
        category = _.find($scope.membershipPlanCategories, function(item) {
          return item.id === id;
        });
        return category != null ? category.label : void 0;
      };
      $scope.getGenerateMakeupClassesForMissedClassesValue = function(val) {
        var replacement_strategy;
        replacement_strategy = (function() {
          switch (val.missed_class_replacement_strategy) {
            case 'generate_one_allowance_for_every_class_missed':
              return 'add one make-up class for each class missed';
            case 'generate_fixed_number_of_allowances_for_all_classes_missed':
              return `add a fixed number of make-up classes (${val.missed_class_replacement_fixed_number})`;
            case 'generate_one_allowance_for_all_classes_missed':
              return 'add one make-up class for all missed classes';
            default:
              return '';
          }
        })();
        return `Yes (missed class threshold: ${val.missed_class_threshold}, ${replacement_strategy})`;
      };
      $scope.getRestrictByEventTypeValue = function(val) {
        var prefix, types, withoutType;
        types = val.event_type_ids.length ? plural('types', val.event_type_ids.length, true) : '';
        prefix = val.event_type_ids.length ? ' + ' : '';
        withoutType = val.book_events_with_no_event_type ? `${prefix}events with no type` : '';
        return `Yes (${types}${withoutType})`;
      };
      $scope.getRestrictByEventStyleValue = function(val) {
        var prefix, styles, withoutStyle;
        styles = val.style_ids.length ? plural('styles', val.style_ids.length, true) : '';
        prefix = val.style_ids.length ? ' + ' : '';
        withoutStyle = val.book_events_with_no_style ? `${prefix}events with no style` : '';
        return `Yes (${styles}${withoutStyle})`;
      };
      $scope.hasPrivilegesChanges = function() {
        return typeof $scope.bulkUpdate.column_changes.classes_limit !== 'undefined';
      };
      $scope.isDefined = function(val) {
        return typeof val !== 'undefined';
      };
      $scope.rowRecord = function(row) {
        return row.record_attributes;
      };
      $scope.getHighlightedCellStyle = function(highlighted) {
        if (highlighted) {
          return {
            'background-color': 'rgba(242,111,33, 0.2)'
          };
        }
      };
      $scope.toggleIgnore = function(row) {
        var message, params, url;
        message = row.ignored ? "This will re-include the selected row in this update. Continue?" : "This will exclude the selected row from this update. Continue";
        if (window.confirm(message)) {
          url = `${bulkUpdateUrl}/${row.id}`;
          params = {
            bulk_record_update_row: {
              ignored: !row.ignored
            }
          };
          row.loading = true;
          return $http.put(url, params).then(function() {
            return $scope.reload();
          }, function() {
            return flash.error = "Request could not be completed. Please try again";
          });
        }
      };
      $scope.changeColumn = function(column) {
        var message, modalSize;
        if ($scope.bulkUpdate.row_validation_in_progress) {
          message = ['Additional changes cannot be made while row validation is in progress.', 'Please wait for validation to finish before applying more changes.'];
          MessageService.message({
            title: 'Action unavailable',
            message: message
          });
          return;
        }
        modalSize = column === 'classes_limit' || column === 'event_type_ids' ? 'lg' : 'md';
        return $modal.open({
          template: require('templates/gyms/bulk_updates/show/change_column_modal.html.slim'),
          resolve: {
            bulkUpdate: function() {
              return $scope.bulkUpdate;
            },
            column: function() {
              return column;
            },
            categories: function() {
              return $scope.membershipPlanCategories;
            }
          },
          controller: 'BulkUpdateChangeColumnCtrl',
          size: modalSize
        });
      };
      $scope.reloadDebounced = _.debounce(function() {
        return $scope.rowsTable.reload();
      }, 300);
      $scope.reload = function() {
        return $scope.rowsTable.reload();
      };
      $scope.confirm = function() {
        return $scope.confirmChanges();
      };
      $scope.isReady = function() {
        return !_.isEmpty($scope.bulkUpdate.column_changes) && !$scope.errorsCount && !$scope.bulkUpdate.row_validation_in_progress;
      };
      $scope.filters = {
        type: 'not_ignored'
      };
      updateErrorsCount = function() {
        var params, query, url;
        params = {
          count: 1,
          filters: {
            type: 'invalid_and_not_ignored'
          }
        };
        query = qs.stringify(params);
        url = `${bulkUpdateUrl}?${query}`;
        return $http.get(url).then(function(response) {
          return $scope.errorsCount = response.data.total;
        });
      };
      return $scope.rowsTable = TableService.init({
        count: 100,
        getData: function(resolve, $params, beforeLoad) {
          var params, query, url;
          if (!$scope.visible) {
            $params.total(0);
            resolve([]);
            return;
          }
          loadingAnimation.show();
          updateErrorsCount();
          params = angular.extend({}, $params.url(), {
            filters: $scope.filters
          });
          beforeLoad(params);
          query = qs.stringify(params);
          url = `${bulkUpdateUrl}?${query}`;
          return $http.get(url).then(function(response) {
            $scope.rows = response.data;
            $params.total(response.data.total);
            resolve(response.data.collection);
            return loadingAnimation.hide();
          }, function() {
            flash.error = "Request could not be completed. Please try again";
            return loadingAnimation.hide();
          });
        }
      });
    }]
  };
});
